module.exports = __webpack_public_path__ + "img/winners-images_02.0a61b98.png";